import { Grid } from "@material-ui/core";
import {
  Modal,
  InputTextMaster,
  MasterButton,
  InputOptionMaster,
} from "App/Component/ui";
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance4,
  TYPE_INSTANCE4,
} from "App/constants";
import { useSelectOptionPost } from "App/hooks";
import {
  defaultToastError,
  defaultToastSuccess,
  isNull,
} from "App/utils/helpers";
import React, { useState } from "react";
import { LIST_URL_WAREHOUSE } from "utils/warehouse";

export const urlCreateBarang = LIST_URL_WAREHOUSE.adjustmentLGS.addBarang;

export const RESET_STATE_DAFTAR_BARANG = {
  adjustment_id: "",
  barang_id: "",
  qty: 0,
  name: "",
  status_id: null,
  statuspengeluaran: "Pilih Status",
  qty_max: 0,
};
export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID",
    align: "left",
    minWidth: "40px",
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "qty",
    disablePadding: false,
    label: "STOK",
    align: "left",
    minWidth: "100px",
  },
];

export const ModalDaftarBarang = ({
  setShowModal,
  formBarang,
  setFormBarang,
  setNewAllData,
}) => {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);

  const handleChange = (text) => (e) => {
    setFormBarang({
      ...formBarang,
      [text]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    try {
      if (isNull(formBarang.barang_id)) {
        defaultToastError("Barang tidak boleh kosong!");
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      } else {
        if (isNull(formBarang.status_id)) {
          defaultToastError("Harap pilih status barang!");
          setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        } else {
          if (formBarang.qty > formBarang.qty_max) {
            defaultToastError("Jumlah permintaan melebihi stok gudang!");
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
          } else {
            const api = await instance4.post(urlCreateBarang, {
              ...formBarang,
            });
            const res = await api?.data;
            if (res.status === 200) {
              setShowModal(false);
              defaultToastSuccess(res?.message);
              await setNewAllData();
            } else {
              defaultToastError(res.message);
            }
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
          }
        }
      }
    } catch (error) {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError(error?.response?.data?.message);
    }
  };

  const dataStatus = useSelectOptionPost(
    true,
    LIST_URL_WAREHOUSE.statusPengeluaranBarangLGS.get,
    TYPE_INSTANCE4
  );

  return (
    <Modal title={`Tambah Barang`} show={setShowModal} width='30%'>
      <form action='POST' onSubmit={(e) => handleSubmit(e)}>
        <p className='mt-1 mb-1'>{formBarang.name}</p>
        <Grid container spacing={1}>
          <InputTextMaster
            type='hidden'
            name='id'
            id='id'
            readOnly={true}
            value={formBarang.barang_id}
          />
          <Grid item sm={6}>
            <InputTextMaster
              name='qty'
              label='BANYAK'
              id='qty'
              value={formBarang.qty}
              onChange={handleChange("qty")}
              placeholder='Banyak'
            />
          </Grid>
          <Grid item sm={6}>
            <InputOptionMaster
              name='status_id'
              label='STATUS'
              id='status_id'
              data={dataStatus}
              withSearch={true}
              value={formBarang.status_id}
              labelValue={formBarang.statuspengeluaran}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormBarang({
                    ...formBarang,
                    status_id: null,
                    statuspengeluaran: "Pilih Status",
                  });
                } else {
                  setFormBarang({
                    ...formBarang,
                    status_id: e?.value,
                    statuspengeluaran: e?.label,
                  });
                }
              }}
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction='row'
          justifyContent='flex-end'
          alignItems='center'>
          <MasterButton
            className={"mt-1"}
            type='submit'
            color={disabled.color}
            name={disabled.label}
            disabled={disabled.disabled}
            size='md'
          />
        </Grid>
      </form>
    </Modal>
  );
};
